import type { FunctionComponent } from 'react'

import {
	Collapse,
	CurrencyDisplay,
	formatCurrencyForDisplay,
	InfoTooltip,
	useIntlConfig,
} from '@monthio/react-components'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ExpandIcon } from '../../../../modulesTemp/shared/ExpandIcon'
import { budgetEstimatesCalculatorService } from './budgetEstimatesCalculatorService'
import {
	AmountAndExpandIconContainer,
	BudgetSectionAmount,
	BudgetSectionContainer,
	BudgetSectionHeader,
	BudgetSectionTitle,
	InitialAmountValue,
} from './styledBudgetEstimates'

export const OverviewSection: FunctionComponent<{
	itemKey: string
	total?: number
	branch?: string
	currentKey?: string
}> = ({ branch, itemKey, total, children }) => {
	const { t } = useTranslation()
	const initialValue = useRef<{ value: number | undefined }>({ value: total })
	const [expanded, setExpanded] = useState(false)
	const [updatedTotal, setUpdatedTotal] = useState<number | undefined>(total)
	const intlConfig = useIntlConfig({ showCurrency: true })
	useEffect(() => {
		const unsubscribe = budgetEstimatesCalculatorService.subscribe((key) => {
			if (key === `${branch}.total`) {
				setUpdatedTotal(budgetEstimatesCalculatorService.getValue(key))
			}
		})

		return unsubscribe
	}, [branch])

	return (
		<BudgetSectionContainer>
			<BudgetSectionHeader onClick={() => setExpanded(!expanded)}>
				<InfoTooltip
					tooltip={t(`${itemKey}-tooltip`)}
					modalTitle={t(`${itemKey}-modalTitle`)}
					variant="blueHelper"
				>
					<BudgetSectionTitle>{t(`${itemKey}-header`)}</BudgetSectionTitle>
				</InfoTooltip>
				<AmountAndExpandIconContainer>
					{typeof updatedTotal === 'number' &&
					initialValue.current?.value != null &&
					initialValue.current?.value !== updatedTotal ? (
						<InitialAmountValue>
							(
							{formatCurrencyForDisplay({
								value: String(initialValue.current?.value),
								decimalsLimit: 0,
								allowNegativeValue: false,
								intlConfig: {
									...intlConfig,
									currency: undefined,
								},
							})}
							)
						</InitialAmountValue>
					) : null}
					<BudgetSectionAmount $positive={branch === 'income'}>
						{typeof updatedTotal === 'number' ? (
							<CurrencyDisplay
								amount={updatedTotal}
								currencyFormatOptions={{
									intlConfig,
									allowNegativeValue: false,
								}}
							/>
						) : null}
					</BudgetSectionAmount>
					<ExpandIcon expanded={expanded} />
				</AmountAndExpandIconContainer>
			</BudgetSectionHeader>
			<Collapse in={expanded} timeout="auto">
				{children}
			</Collapse>
		</BudgetSectionContainer>
	)
}
